import React from "react";
import Link from "gatsby-link";
import GatsbyConfig from "../../../gatsby-config.js";

const { siteMetadata: config } = GatsbyConfig;

class Icon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M19.5 14c-.696 0-1.324.285-1.777.743l-.315-.158A5.954 5.954 0 0018 12c0-.699-.126-1.367-.345-1.991l1.56-1.17A2 2 0 1018 7c0 .08.014.155.023.233l-1.348 1.011a6.001 6.001 0 00-2.52-1.838l.203-1.678c.388-.272.642-.719.642-1.228a1.5 1.5 0 00-3 0c0 .377.144.718.374.981l-.185 1.529C12.125 6.008 12.064 6 12 6a5.974 5.974 0 00-2.861.725L6.926 4.512C6.969 4.347 7 4.178 7 4a2 2 0 10-2 2c.178 0 .347-.031.512-.074L7.56 7.974a5.994 5.994 0 00-.851 1.198l-1.913-.415A1.494 1.494 0 002 9.5 1.5 1.5 0 003.5 11c.328 0 .629-.108.876-.287l1.702.369c-.047.3-.078.605-.078.918 0 .768.15 1.499.412 2.174l-1.899 1.899A2.024 2.024 0 004 16c-1.105 0-2 .874-2 1.953s.895 1.953 2 1.953 2-.874 2-1.953c0-.164-.027-.321-.066-.473l1.544-1.544a6.024 6.024 0 002.117 1.56l-.148.592A1.992 1.992 0 008 20a2 2 0 103.39-1.435l.147-.589c.153.012.307.024.463.024a5.982 5.982 0 004.245-1.76l.768.384A2.494 2.494 0 0019.5 19a2.5 2.5 0 100-5zM8 13a1 1 0 112 0 1 1 0 01-2 0zm3.5-3a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0111.5 10zm2.5 6a2 2 0 11-.001-3.999A2 2 0 0114 16z" />
      </svg>
    );
  }
}

export default class CovidCallout extends React.Component {
  render() {
    const { trip } = this.props;
    const tripData = config.trips[trip];

    return (
      <div className="covid-callout">
        <div className="wrap">
          <h2>
            <Icon /> Health &amp; Safety Info
          </h2>
          <Link className="btn btn-rounded" to={`/${trip}/faq/?tab=covid`}>
            Read More
            <i className="fa fa-external-link" />
          </Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/covid-callout.js